import React from "react";

import { ShadeSelector } from "../../ShadeSelector/ShadeSelector";

import { horizontalProductCardColorSwatchWrapper } from "./HorizontalProductCard.css";
import type { ProductCardDataType } from "./types";

type Props = {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  product: Pick<ProductCardDataType, "swatchImages" | "variationName">;
  visibleItemCount?: number;
};

export const HorizontalProductCardColorSwatch: React.FC<Props> = ({
  onClick,
  product,
  visibleItemCount = 4
}) => {
  if (!product.swatchImages?.length) return null;

  const title = product.variationName || "Select shade";

  const handleClick = onClick
    ? (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
      }
    : undefined;

  return (
    <div className={horizontalProductCardColorSwatchWrapper}>
      <ShadeSelector
        title={title}
        shades={product.swatchImages}
        previewCount={visibleItemCount}
        onClick={handleClick}
        dataTestId="horizontal-product-card-colour-swatch"
        variant="compact"
        showShadow={false}
      />
    </div>
  );
};
